import login from './login';
import applyFor from './applyFor';
import InterviewPanel from './InterviewPanel';
import Calendar from './Calendar';
import AccountPopover from './AccountPopover';
import common from './common';

const config = {
  login,
  applyFor,
  InterviewPanel,
  Calendar,
  AccountPopover,
  common,
};

export default config;
